import styled from "styled-components";
import BodySmall from "../typography/BodySmall";
import type { FC } from "react";

const checkedIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3.75" y="3.75" width="17.5" height="17.5" rx="8.75" fill="white" />
    <rect
      x="3.75"
      y="3.75"
      width="17.5"
      height="17.5"
      rx="8.75"
      stroke="#515D5E"
      strokeWidth="1.5"
    />
    <rect x="8" y="8" width="9" height="9" rx="4.5" fill="#515D5E" />
  </svg>
);

const uncheckedIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3.75" y="3.75" width="17.5" height="17.5" rx="8.75" fill="white" />
    <rect
      x="3.75"
      y="3.75"
      width="17.5"
      height="17.5"
      rx="8.75"
      stroke="#515D5E"
      strokeWidth="1.5"
    />
  </svg>
);

const RadioButtonWrapper = styled.label<{ disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  filter: ${(props) => (props.disabled ? "opacity(0.4)" : "none")};
  padding-left: 0;
`;

const HiddenRadioButton = styled.input.attrs({ type: "radio" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

const Icon = styled.div<{ isChecked: boolean }>`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 4px;
  margin-right: 8px;
  color: #fff;
`;

interface Props {
  checked: boolean;
  onChange?: any;
  title?: string;
  disabled?: boolean;
  name?: string;
}

const RadioButton: FC<Props> = ({
  checked,
  onChange,
  title,
  disabled,
  name,
}) => {
  const handleChange = (e: any) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <RadioButtonWrapper disabled={disabled} onChange={handleChange}>
      <HiddenRadioButton checked={checked} disabled={disabled} name={name} />
      <Icon isChecked={checked}>{checked ? checkedIcon : uncheckedIcon}</Icon>
      <BodySmall>{title}</BodySmall>
    </RadioButtonWrapper>
  );
};

export default RadioButton;
